import { useSelector } from 'react-redux'
import { appLanguageSelector } from '../../../redux/app/selectors'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { filtersSelector } from '../../../redux/context/filters/selectors'
import { store } from '../../../redux/store'
import { Store } from '../../../redux/types'
import { Language } from '../../../types/user/User'
import { useDimensionQuery } from '../../../features/dimension/hooks/hooks'

export const useContextParameters = () => {
  const state = store.getState() as unknown as Store
  const companyId = useSelector(contextCompanyIdSelector)!
  const { budgetingScenario, periodGroups } = filtersSelector(state)
  const dimensionQuery = useDimensionQuery()
  const lng = appLanguageSelector(state)

  const contextParams = {
    companyId,
    periodGroups: periodGroups || [],
    lng: lng || Language.fi,
    dimensions: dimensionQuery || [],
    budgetingScenarioId: (budgetingScenario && budgetingScenario.id) || null
  }
  return contextParams
}
